// extracted by mini-css-extract-plugin
export default {"message":"styles_message__ttmi2","info":"styles_info__J2x4U","buttons":"styles_buttons__Y6pEC","button":"styles_button__6Sgp-"};